<!-- 商务合作 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 title="商务合作" label="INFORMARION" :showTitle="true" :showOrder="false" :showMore="false" :infoPage="infoPage" :infoBlock="infoBlock" :tabList="tabList" :tabDefaultType="tabDefaultType" count="10" v-on:queryPage="zsyz_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="推荐政策" :showTitle="true" :infoBlock="infoBlock3" count="3"/>
        <infoList title="推荐项目" :showTitle="true" :infoBlock="infoBlock4" count="3"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import JghqInfo2 from '../module/JghqInfo2'
import SgqgInfo from '../module/SgqgInfo'
import InfoList from '../block/InfoList'

import TitleInfoBlock01 from '../block/TitleInfoBlock01'
import TjInfo1 from '../module/TjInfo1'

export default {
  name: 'Lxwm03',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList': InfoList,
  },
  data() {
    return {
      msg: '',
      infoBlock:JghqInfo2,
      infoBlock3:TitleInfoBlock01,
      infoBlock4:TjInfo1,

      infoPage:{},
      tabList:[{title:"招商政策",type:'1'},{title:"招商项目",type:'2'}],
      tabDefaultType:'1',
    }
  },
  methods:{
    //招商引资
    zsyz_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.referenceLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Lxwm03.vue